import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/card/Card';
import IconHeadset from '@spothero/icons/headset';

const CONTENT = [
    {
        label: 'What is SpotHero?',
        description:
            'SpotHero connects drivers to the best parking spots in 300+ cities in North America. You can use our app and website to book your spot ahead of time.',
    },
    {
        label: 'What if my travel plans change?',
        description:
            'There’s no fee to edit or extend your reservation. Also, most of the parking facilities we work with offer free cancellation up to start time.',
    },
    {
        label: 'Is there a shuttle to the terminal?',
        description:
            'Yes, the majority of parking facilities offer free shuttle service. You can see shuttle info on the results page before you book your spot.',
    },
];

const CustomerSupport = ({phoneNumber, phoneNumberFriendly, hours}) => (
    <Card className="CustomerSupport">
        <div className="CustomerSupport-heading">
            <IconHeadset className="CustomerSupport-heading-icon" />
            <h2 className="CustomerSupport-title">
                7-Day Customer Support, Even Holidays
            </h2>
            <div className="CustomerSupport-phone-hours">
                <span className="phone">
                    Support Number: {phoneNumberFriendly}
                </span>
                <span className="hours">{hours}</span>
            </div>
        </div>
        <div className="CustomerSupport-content">
            <ul className="CustomerSupport-faqs">
                {CONTENT.map((item, index) => {
                    return (
                        <li key={index} className="CustomerSupport-faq">
                            <h3 className="item-label">{item.label}</h3>
                            <p className="item-description">
                                {item.description}
                            </p>
                        </li>
                    );
                })}
            </ul>

            <div className="CustomerSupport-phone-hours">
                <span className="phone">
                    Support Number:{' '}
                    <a href="tel:phoneNumber">{phoneNumberFriendly}</a>
                </span>
                <span className="hours">{hours}</span>
            </div>
        </div>
    </Card>
);

CustomerSupport.propTypes = {
    phoneNumber: PropTypes.string,
    phoneNumberFriendly: PropTypes.string,
    hours: PropTypes.string,
};

export default CustomerSupport;
